<template>
  <div class="l-edit-dialog-box">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="left" v-loading="loading">
      <el-row :gutter="50" style="margin-left:0;margin-right:0">
    
        <el-col :span="24">
          <el-form-item label="用户ID" prop="DisplayId">
            <el-input v-model="form_data.DisplayId" autocomplete="off" placeholder="请输入用户ID"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="有效天数" prop="days">
            <el-input v-model="form_data.days" autocomplete="off" placeholder="请输入有效天数："></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="起始自选号码" prop="startWith">
            <el-input v-model="form_data.startWith" autocomplete="off" placeholder="请输入起始自选号码"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="可选靓号个数" prop="choiceCount">
            <el-input v-model="form_data.choiceCount" autocomplete="off" placeholder="可选靓号个数"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="总长度位数" prop="length">
            <el-input v-model="form_data.length" autocomplete="off" placeholder="请输入总长度位数"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="充值截图" prop="photo">
            <l-upload-img method="adminUserAdditional_upload" accept=".jpg,.png,.bmp" name="img" 
              :on-success="(res) => handleUploadSuccess(res, 'photo')" :preview-url="photo_preview">
            </l-upload-img>
          </el-form-item>
        </el-col>
          
        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250"
              placeholder="请输入备注" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: 'l-lottery-edit',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    }
  },

  components: {
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  // watch: {

  // },
  data() {
    return {
      upload_url: Vue.$_config.upload_url,
      fileList: [],
      // 修改 的图片
      photo_preview: "",
      photo_2_preview: "",
      loading: false,//页面是否加载中
      app_list:
      {
        1: "星伴"
      }
      ,
      //是否显示
      value1: '',
      //表单数据
      form_data: {
        DisplayId: "",
        photo: [],
        days:7,
        startWith:"",
        length:6,
        choiceCount:1
      },
      //表单验证规则
      rules: {
        DisplayId: [
          { required: true, message: '用户ID不能为空', trigger: 'change' }
        ],
        choiceCount: [
          { required: true, message: '靓号个数不能为空', trigger: 'change' }
        ],
        days: [
          { required: true, message: '有效期不能为空', trigger: 'change' }
        ],
        startWith: [
          { required: true, message: '起始自选号码不能为空', trigger: 'change' }
        ],
        photo: [
          { required: true, message: '截图不能为空', trigger: 'change' }
        ],
        length: [
          { required: true, message: '总长度位数不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  methods: {
    //上传图标成功后的回调
    handleUploadSuccess(res, field) {
      this.form_data.photo.push(res.data.photo);
      this[field + "_preview"] = res.data.photo;
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },

    //提交数据
    handleSubmit() {
      // console.log(this.form_data);
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.form_data.choiceCount > 9){
            this.$_msg.error();('靓号个数最高9个');
            return;
          }
          this.submitting = true;
          this.$_invoke('adminUserLottery_save', this.form_data).then(() => {
            this.$_msg.success('添加成功');
            this.$emit('on-success');
          }).finally(() => {
            this.submitting = false;
          })
        }
      }
      )

    },
  },
}
</script>